import { Field, FieldProps } from 'formik';
import { TextField } from "formik-material-ui";
import React, { FunctionComponent } from "react";
import { Option } from "./Option";

interface AdditionalProps {
    id: string;
    fieldName: string;
    fieldLabel: string;
    fieldOptions: () => Option[];
    fieldValidator: (value: any) => string;
    required: boolean;
    defaultValue: any;
}

type TextFieldEditorProps = FieldProps & AdditionalProps;

const TextFieldEditor: FunctionComponent<TextFieldEditorProps> =  ({ id, fieldLabel, fieldName, fieldValidator, fieldOptions, defaultValue, ...props }) => {

    return (
        <Field
            {...props}
            id={id}
            component={TextField}
            margin="dense"
            label={fieldLabel}
            variant="filled"
            name={fieldName}
            fullWidth
            validate={fieldValidator}
            defaultValue={defaultValue}
            InputLabelProps={{
                shrink: true,
            }}
        />
    )
}

export default TextFieldEditor;
